<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="crud.title" :rules="[rules.required]" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="crud.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="crud.lesson_file"
          label="Video"
          accept="video/*"
          show-size
          prepend-icon
          append-icon="mdi-video"
        >
          <template v-slot:selection v-if="typeof crud.lesson_file === 'string'"
            >You already saved a file. Click to save a new one...</template
          >
        </v-file-input>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="crud.rich_title"
          :rules="[rules.required]"
          label="Rich Text Title"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <span class="font-weight-semibold">
          Vocabulary Rich Text Here
          <v-icon size="20" class="mb-1" color="black">mdi-arrow-down</v-icon>
        </span>
        <app-editor ref="editor" v-model="crud.rich_text"></app-editor>
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-for="(question, index) in crud.question_group.questions"
        :key="'Question' + index"
      >
        <app-pronunciation-card
          v-model="question.question_file"
          :content.sync="question.content"
          @delete="removeQuestion(index)"
        />
      </v-col>
      <v-col cols="12">
        <app-add @new-exercise="onNewWord">Add New Word</app-add>
      </v-col>
      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto"
        >Save</v-btn
      >
    </v-row>
  </v-form>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
import rulesMixin from "@/mixins/rulesMixin";
import pronunciationMixin from "@/mixins/pronunciationMixin";
import audioMixin from "@/mixins/audioMixin";
import restoreMixin from "@/mixins/restoreMixin";
import { getVocabulary, postVocabulary, postQuestions } from "@/api/api";
import Add from "@/components/Admin/crud/Grammar/Add.vue";
import PronunciationCard from "./Pronunciation/PronunciationCard.vue";

export default {
  components: {
    appAdd: Add,
    appPronunciationCard: PronunciationCard,
    appEditor: Editor,
  },
  props: {
    direction: {
      required: false,
      default: "",
      type: String,
    },
  },
  mixins: [rulesMixin, restoreMixin, audioMixin, pronunciationMixin],
  data() {
    return {
      loading: false,
      crud: {
        title: "",
        subtitle: "",
        lesson_file: undefined,
        rich_title: "",
        rich_text: {
          type: "doc",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Rich Text here...",
                },
              ],
            },
          ],
        },
        question_group: {
          name: "Pronunciation",
          questions: [],
        },
      },
    };
  },
  computed: {
    teacher_lesson() {
      return this.$store.getters["admin/teacher_lesson"];
    },
    practice() {
      return this.$store.getters["admin/practice"];
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let crud = { ...this.crud };
      try {
        crud.rich_text = JSON.stringify(crud.rich_text);
        if (this.direction) {
          crud.practice = this.practice.uuid;
        } else crud.teacher_lesson = this.teacher_lesson.uuid;

        const response = await postVocabulary(crud);
        if (response.data.question_group.uuid) {
          this.crud.question_group.uuid = response.data.question_group.uuid;
        } else this.crud.question_group.uuid = response.data.question_group;
        let newQuestions = JSON.parse(JSON.stringify(this.crud.question_group));
        newQuestions.questions = newQuestions.questions.map((element, index) => {
          element.content = JSON.stringify(element.content);
          element.question_file = this.crud.question_group.questions[index].question_file;
          return element;
        });
        const questions = await postQuestions(newQuestions);
        this.crud.question_group.uuid = questions.uuid;
        this.crud.question_group.questions.forEach((element, index) => {
          element.uuid = questions.questions[index].uuid;
        });
        this.crud.uuid = response.data.uuid;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loading = false;
    },
    async create() {
      let uuid = "";
      let direction;

      if (this.direction) {
        uuid = this.practice.vocabulary_step;
        direction = "practice";
      } else {
        uuid = this.teacher_lesson.vocabulary_step;
        direction = "teach";
      }

      if (uuid) {
        const response = await getVocabulary(uuid, direction);
        let crud = response.data;
        crud.rich_text = JSON.parse(crud.rich_text);
        this.crud = { ...crud };
        this.crud.question_group.questions = this.crud.question_group.questions.map((element) => {
          element.content = JSON.parse(element.content);
          return element;
        });
        this.$refs.editor.editor.setContent(crud.rich_text);
      }
    },
  },
  created() {
    this.create();
  },
};
</script>
